import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { notification } from "antd";
import React, { useEffect } from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import Helper from "../../../Helper";
import { ExecutiveCommandView } from "../../../models/ExecutiveCommandView";
import PlotAPI from "../../../plotAPI";
type ExecutiveCommandNameProps = {
    open: boolean;
    refreshViews: () => void;
    toggleModal: () => void;
    selectedView: ExecutiveCommandView | null;
};

const ExecutiveCommandName: React.FC<ExecutiveCommandNameProps> = ({
    open,
    refreshViews,
    toggleModal,
    selectedView,
}) => {
    const context = React.useContext(GlobalStoreContext);

    const [name, setName] = React.useState<string>("");

    useEffect(() => {
        if (selectedView) {
            setName(selectedView.name);
        }
    }, [selectedView]);
    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!selectedView) {
            return;
        }
        const tempView = Object.create(selectedView) as ExecutiveCommandView;
        tempView.name = name;

        PlotAPI.saveExecutiveCommandView(context.currentTeam, tempView).then((res) => {
            if (res) {
                notification.success({
                    message: "Success",
                    description: "Executive Command View saved successfully.",
                });
                Helper.setCookie("executive_command_view", res.id, 365);
                refreshViews();
                toggleModal();
            }
        });
    };
    return (
        <Dialog open={open} onClose={toggleModal}>
            <DialogTitle>Executive Command View Name</DialogTitle>
            <DialogContent>
                <DialogContentText>Please enter a name for this view.</DialogContentText>
                <form onSubmit={onSubmit} id="subscription-form">
                    <TextField
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                        required
                        value={name}
                        margin="dense"
                        id="name"
                        name="name"
                        label="View Name"
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={toggleModal}>Cancel</Button>
                <Button type="submit" form="subscription-form">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ExecutiveCommandName;
